import ActionTypes from "../constants/ActionTypes";

const initialState = {
    hasError: false,
    errorMessage: '',
    isLoading: false,
    isSuccess: false,
    documentTemplates: []
};

export default (state = initialState, action) => {
    const { type } = action;
    switch (type) {
        case ActionTypes.GUEST_DOCUMENT_TEMPLATE_SETTING_REQUEST:
            return {
                ...state,
                isSuccess: false,
                isLoading: true,
                hasError: false
            };
        case ActionTypes.GUEST_DOCUMENT_TEMPLATE_SETTING_SUCCESS:
            return {
                ...state,
                documentTemplates: action.payload || state.documentTemplates,
                isSuccess: true,
                isLoading: false,
                hasError: false
            };
        case ActionTypes.GUEST_DOCUMENT_TEMPLATE_SETTING_FAILURE:
            return {
                ...state,
                hasError: true,
                isLoading: false,
                isSuccess: false,
                errorMessage: action.errorMessage
            };
        default:
            return state;
    }
};
